module.exports = __webpack_public_path__ + "assets/Landing_Banner.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/Landing_Banner.jpg
 ** module id = 201
 ** module chunks = 1
 **/